module.exports = __webpack_public_path__ + "static/media/logo.823e74da.svg";